import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  loadProductProperties,
  loadPropertiesByRawNames,
  propertiesLoad,
  propertyAdd,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(propertyAdd.type, send, socket);
  yield takeEvery(loadPropertiesByRawNames.type, send, socket);
  yield takeEvery(loadProductProperties.type, send, socket);
  yield takeEvery(propertiesLoad.type, send, socket);
}
